import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useCallback, useEffect } from "react";
import { Button as BaseButton } from "sprout-ui-dom/dist/Button";
import { ArrowBackIosOutlined, Close } from "sprout-ui-icons";
import { media } from "sprout-ui-theme";
import styled from "styled-components";
import Dialog from "../Dialog";
import { MoveItemsDialogView, useMoveItemsDialog } from "./MoveItemsDialogContext";
import MoveItemsDialogQuery from "./MoveItemsDialog_Query";
const Button = styled(BaseButton)`
  ${media.up("small")} {
    margin-left: -12px;
  }
`;
const CloseButton = styled(Button)`
  ${media.up("small")} {
    display: none;
  }
`;
const MoveItemsDialogInner = (props)=>{
    const { open , onRequestClose , onSuccess  } = props;
    const { view , setView , setCurrentTopicId , initialCurrentTopicId  } = useMoveItemsDialog();
    useEffect(()=>{
        if (!open) setView(MoveItemsDialogView.CLEAN);
        else setCurrentTopicId(initialCurrentTopicId);
    }, [
        initialCurrentTopicId,
        open,
        setCurrentTopicId,
        setView
    ]);
    /**
   * Back button that is context aware, good idea, but bad usability.
   */ // const handleBack = useCallback(() => {
    //   if (view === MoveItemsDialogView.SCOPED) {
    //     setView(MoveItemsDialogView.CLEAN);
    //     setCurrentTopicId(initialCurrentTopicId);
    //   }
    //   if (view === MoveItemsDialogView.ADD) {
    //     if (currentTopicId === initialCurrentTopicId) {
    //       setView(MoveItemsDialogView.CLEAN);
    //     } else {
    //       setView(MoveItemsDialogView.SCOPED);
    //     }
    //   }
    // }, [initialCurrentTopicId, setCurrentTopicId, setView, view, currentTopicId]);
    /**
   * Back button that is "hard-reset"
   */ const handleBack = useCallback(()=>{
        setView(MoveItemsDialogView.CLEAN);
        setCurrentTopicId(initialCurrentTopicId);
    }, [
        setView,
        setCurrentTopicId,
        initialCurrentTopicId
    ]);
    const handleClose = useCallback(()=>{
        onRequestClose(new Error("Closing `MoveItemsDialog"));
    }, [
        onRequestClose
    ]);
    return /*#__PURE__*/ _jsx(Dialog, {
        open: open,
        onRequestClose: onRequestClose,
        contextualTitle: view === MoveItemsDialogView.ADD ? "Add branch" : "Move to...",
        leftAction: /*#__PURE__*/ _jsxs(_Fragment, {
            children: [
                [
                    MoveItemsDialogView.ADD,
                    MoveItemsDialogView.SCOPED
                ].includes(view) && /*#__PURE__*/ _jsx(Button, {
                    onClick: handleBack,
                    variant: "circle-bright-blue-bg",
                    color: "white.100",
                    children: /*#__PURE__*/ _jsx(ArrowBackIosOutlined, {})
                }),
                view === MoveItemsDialogView.CLEAN && /*#__PURE__*/ _jsx(CloseButton, {
                    onClick: handleClose,
                    variant: "circle-bright-blue-bg",
                    color: "white.100",
                    children: /*#__PURE__*/ _jsx(Close, {})
                })
            ]
        }),
        children: /*#__PURE__*/ _jsx(MoveItemsDialogQuery, {
            onRequestClose: onRequestClose,
            onSuccess: onSuccess
        })
    });
};
export default MoveItemsDialogInner;
